export const BUILDER_PUBLIC_KEY = '425a1e92273943bab5fbaee91f6e709e';

export const editryConfig = {
  baseUrl: process.env.REACT_APP_EDITRY_BASE_URL || 'https://admin.lazylabs.cz',
  editryToken:
    process.env.REACT_APP_EDITRY_TOKEN ||
    '0dc150a62b7aae55481799630452dc20c11144190c10e44fcd0687410417393c',
  secretToken: process.env.REACT_APP_EDITRY_SECRET_TOKEN || undefined
};

export function isEditryConfigured() {
  return Boolean(editryConfig.baseUrl && editryConfig.editryToken);
}
